module.exports = "/build/web/images/work-method-splitpayment.c7077254c43dd2febac8061d8aabe69a.png";


//////////////////
// WEBPACK FOOTER
// ./images/work-method-splitpayment.png
// module id = 139
// module chunks = 11